<script lang="ts">
  import { donBaseURL, donClientID, redirectURL } from './values'
  import { mastodonAccessToken, mastodonUser } from './store'

  let authed = false
  mastodonAccessToken.subscribe((v) => {
    if(v === null) authed = true
    console.log(v)
  })

  function redirectToLogin() {
    const url = `${donBaseURL}/oauth/authorize?response_type=code&client_id=${donClientID}&redirect_uri=${redirectURL}`
    location.href = url
  }

  let username = ''
  
  mastodonUser.subscribe((v) => {
    console.log(v)
    if(v !== null) username = v.display_name || v.username
  })
</script>

<div>
  {#if authed}
    <button on:click={redirectToLogin}>
      Login
    </button>
  {:else}
    <h3>{ username }さん、こんにちは</h3>
  {/if}
  
</div>